import { type WorkspaceAgentMessagePill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';
import { markWorkspaceAgentArtifactHydrationPill } from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentArtifactHydration';
import { markWorkspaceAgentCommentMonikerPill } from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentCommentMoniker';
import { markWorkspaceAgentDirectAssetMonikerPill } from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentDirectAssetMoniker';

const isWorkspaceAgentArtifactCitationPill = (pill: WorkspaceAgentMessagePill): boolean =>
  pill.type === 'assetList' || pill.type === 'boardList' || pill.type === 'changePreview' || pill.type === 'table';

const isVersionlessAssetPill = (
  pill: WorkspaceAgentMessagePill,
): pill is Extract<WorkspaceAgentMessagePill, { type: 'asset' }> =>
  pill.type === 'asset' && pill.versionId === undefined;

export type MarkWorkspaceAgentContentSynthesizedMonikerPillOptions = {
  /**
   * Agent-panel table cells hydrate artifact citations through the session APIs.
   * Off-session callers (skill instructions, automation readouts) leave this off so a
   * count-only placeholder does not stay pending with no session.
   */
  markArtifactHydration?: boolean;
};

/** WeakSet marks for pills parsed from `@[…]` monikers in content (not `metadata.pills`). */
export const markWorkspaceAgentContentSynthesizedMonikerPill = (
  pill: WorkspaceAgentMessagePill,
  { markArtifactHydration = false }: MarkWorkspaceAgentContentSynthesizedMonikerPillOptions = {},
): void => {
  if (markArtifactHydration && isWorkspaceAgentArtifactCitationPill(pill)) {
    markWorkspaceAgentArtifactHydrationPill(pill);
  }

  if (isVersionlessAssetPill(pill)) {
    markWorkspaceAgentDirectAssetMonikerPill(pill);
  }

  if (pill.type === 'comment') {
    markWorkspaceAgentCommentMonikerPill(pill);
  }
};
